import * as types from '../types.js';

export default {

	html: `
		<style>
			#move-stock #stock_sku		{ width: 9rem;	}
			#move-stock #lot_company_id	{ width: 10rem;	}
			#move-stock #lot_id			{ width: 10rem;	}
			#move-stock #quantity		{ width: 5rem; text-align: right;	}
			#move-stock #output_id		{ width: 5rem; text-align: right;	}
			#move-stock #reason			{ width: 11rem;	}
			#move-stock .company		{ width: 10rem;	}
			#move-stock .warehouse		{ width: 10rem;	}
			#move-stock .location		{ width: 9rem;	}
			#move-stock .stock			{ width: 8rem;	}
		</style>
		<form id="move-stock" class="form" autocomplete="off">
			<datalist id="move-companies">
			</datalist>
			<datalist id="move-products">
			</datalist>
			<datalist id="source-warehouses">
			</datalist>
			<datalist id="target-warehouses">
			</datalist>
			<datalist id="target-locations">
			</datalist>
			<div class="title">
				Mover Estoque
			</div>
			<div class="fsb mtl">
				<label title="SKU do produto (informação, preenchido ao selecionar estoque)">SKU
					<input id="stock_sku" type="text" list="move-products" placeholder="Ex.: Y8GZ5A ou buscar produto">
				</label>
				<label title="Empresa titular do lote">Titular<sup>*</sup>
					<input id="lot_company_id" type="text" list="move-companies" required>
				</label>
				<label title="Lote (identificador do sistema, somente leitura)">Lote<sup>*</sup>
					<input id="lot_id" type="text" required readonly>
				</label>
				<label title="Quantidade a mover">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Identificador da saída em caso de reserva">Saída
					<input id="output_id" type="text">
				</label>
				<label title="Justificativa para a operação">Motivo<sup>*</sup>
					<input id="reason" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa de origem">Origem<sup>*</sup>
					<input id="source_warehouse_company_id" class="company" type="text" list="move-companies" required>
				</label>
				<label title="Armazém de origem">Armazém<sup>*</sup>
					<input id="source_warehouse_id" class="warehouse" type="text" list="source-warehouses" required>
				</label>
				<label title="Posição de origem (somente leitura)">Posição<sup>*</sup>
					<input id="source_location_id" class="location" type="text" required readonly>
				</label>
				<label title="Saldo de origem">De<sup>*</sup>
					<select id="source_stock" class="stock" required>
						<option value="L">Disponível</option>
						<option value="R">Reservado</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa de destino">Destino<sup>*</sup>
					<input id="target_warehouse_company_id" class="company" type="text" list="move-companies" required>
				</label>
				<label title="Armazém de destino">Armazém<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="target-warehouses" required>
				</label>
				<label title="Posição de destino">Posição<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="target-locations" required>
				</label>
				<label title="Saldo de destino">Para<sup>*</sup>
					<select id="target_stock" class="stock" required>
						<option value="L">Disponível</option>
						<option value="R">Reservado</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#move-stock',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.form.eraseValues();
			formset.loadList('#move-companies', 'companies', { labels: ['nick'], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#lot_company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#stock_sku' }, types: [types.pubsub(), types.datalist(), types.observer('lot_company_id'), types.obs_load_options('products', { labels: ['sku', 'name'], value: 'sku' })] },
		{ properties: { selector: '#lot_id' }, types: [types.pubsub(), types.number(0, 2)] },
		{ properties: { selector: '#quantity' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#output_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#reason' }, types: [] },
		{ properties: { selector: '#source_warehouse_company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#target_warehouse_company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#source_warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('source_warehouse_company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#target_warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('target_warehouse_company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#source_location_id' }, types: [types.pubsub(), types.number(0, 2)] },
		{ properties: { selector: '#target_location_id' }, types: [types.pubsub(), types.datalist(), types.observer(['target_warehouse_company_id', 'target_warehouse_id']), types.obs_load_options('locations', { labels: ['address'], sep: '-', key: 'target_warehouse_company_id' })] },
		{ properties: { selector: '#source_stock' }, types: [types.select()] },
		{ properties: { selector: '#target_stock' }, types: [types.select()] },
	]

};

